import { render, staticRenderFns } from "./EcosystemsCrawling.vue?vue&type=template&id=07764c56&scoped=true"
import script from "./EcosystemsCrawling.vue?vue&type=script&setup=true&lang=js"
export * from "./EcosystemsCrawling.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07764c56",
  null
  
)

export default component.exports